import { findIndex } from "../lib/lodash";

const initState = {
  cartItems: [],
  open: false,
  shippingCost: 0
};
export default function cart(state = initState, action) {
  switch (action.type) {
    case "ADD_CARTITEM": {
      const { productId, optionId } = action;
      const newCartItems = [...state.cartItems];
      const index = findIndex(
        newCartItems,
        i => i.productId === productId && i.optionId === optionId
      );
      if (index === -1) {
        newCartItems.push({ productId, optionId, quantity: 1 });
      } else {
        newCartItems[index].quantity += 1;
      }
      return {
        ...state,
        cartItems: newCartItems
      };
    }
    case "REMOVE_CARTITEM": {
      const { productId, optionId } = action;
      const newCartItems = [...state.cartItems];
      const index = findIndex(
        newCartItems,
        i => i.productId === productId && i.optionId === optionId
      );
      if (index > -1) {
        newCartItems.splice(index, 1);
      }
      return {
        ...state,
        cartItems: newCartItems
      };
    }
    case "CHANGE_ORDER_QUANTITY": {
      const { productId, optionId, quantity } = action;
      if (isNaN(quantity) || quantity <= 0) return state;
      const newCartItems = [...state.cartItems];
      const index = findIndex(
        newCartItems,
        i => i.productId === productId && i.optionId === optionId
      );
      newCartItems[index].quantity = quantity;
      return {
        ...state,
        cartItems: newCartItems
      };
    }
    case "CLEAR_CART":
    case "CHECKOUT_SUCCESS": {
      return {
        ...state,
        cartItems: []
      };
    }
    case "TOGGLE_CART": {
      return {
        ...state,
        open: action.bool
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cart.js